module.exports = __webpack_public_path__ + "img/Presotea.49d11fc9.svg";